import React from "react";
import styles from "./QcreativesFor.module.scss";
import { FaArrowRightLong } from "react-icons/fa6";
import Button from "components/UI/Button/Button";
import QcreativesIcon from "../../../../images/creatives-for.png";
import { useNavigate } from "react-router-dom";

const navigationBtns = [
  {
    text: "Find Projects",
    href: "/projects",
  },
  {
    text: "Find Businesses",
    href: "/feed",
  },
  {
    text: "Find Creatives",
    href: "/feed",
  },
];

const QcreativesFor = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.qcreatives}>
      <div className={styles.content}>
        <h2 className={styles.title}>Who is Qreativs for?</h2>
        <p>Anyone looking to navigate their professional life.</p>
        <div className={styles.btns}>
          {navigationBtns.map((btn) => (
            <Button
              key={btn.text}
              variant="outlined"
              className={styles.btn}
              onClick={() => {
                navigate(btn.href);
              }}
            >
              <span>{btn.text}</span> <FaArrowRightLong />
            </Button>
          ))}
        </div>
      </div>
      <img
        src={QcreativesIcon}
        alt="Qcreatives-Icon"
        className={styles.qcreativesIcon}
      />
    </div>
  );
};

export default QcreativesFor;
